import type { AppStoreAudioCaptureStore } from "@/store/audio-capture/AppStoreAudioCaptureStore";
import { AudioCaptureRestorer } from "@/store/audio-capture/restoration/audio-capture-restorer";
import { ProcessRecordingWorkflow } from "@/store/audio-capture/processing/process-recording-workflow";
import type { VoiceAnalyticsTracker } from "@/store/audio-capture/analytics/voice-analytics-tracker";
import { ProcessingManager } from "@/store/audio-capture/managers/processing-manager";

export class WorkflowManager {
  private readonly restorer: AudioCaptureRestorer;
  private readonly processWorkflow: ProcessRecordingWorkflow;

  constructor(
    private readonly store: AppStoreAudioCaptureStore,
    private readonly analytics: VoiceAnalyticsTracker,
    private readonly processing: ProcessingManager
  ) {
    this.restorer = new AudioCaptureRestorer(this.store);
    this.processWorkflow = new ProcessRecordingWorkflow(
      this.store,
      this.analytics,
      this.processing
    );
  }

  async restoreFromDb({ signal }: { signal: AbortSignal }): Promise<void> {
    await this.restorer.restore({ signal });
  }

  async processRecording(): Promise<void> {
    await this.processWorkflow.run();
  }
}
